var RAL_CODES = {
  1000: "#CDBA88",
  1001: "#D0B084",
  1002: "#D2AA6D",
  1003: "#F9A900",
  1004: "#E49E00",
  1005: "#CB8F00",
  1006: "#E19000",
  1007: "#E88C00",
  1011: "#AF8050",
  1012: "#DDAF28",
  1013: "#E3D9C7",
  1014: "#DDC49B",
  1015: "#E6D2B5",
  1016: "#F1DD39",
  1017: "#F6A951",
  1018: "#FACA31",
  1019: "#A48F7A",
  1020: "#A08F65",
  1021: "#F6B600",
  1023: "#F7B500",
  1024: "#BA8F4C",
  1026: "#FFFF00",
  1027: "#A77F0F",
  1028: "#FF9C00",
  1032: "#E2A300",
  1033: "#F99A1D",
  1034: "#EB9C52",
  1035: "#8F8370",
  1036: "#806440",
  1037: "#F09200",
  2000: "#DA6E00",
  2001: "#BA481C",
  2002: "#BF3922",
  2003: "#F67829",
  2004: "#E25304",
  2005: "#FF4D08",
  2007: "#FFB200",
  2008: "#EC6B22",
  2009: "#DE5308",
  2010: "#D05D29",
  2011: "#E26E0F",
  2012: "#D5654E",
  2013: "#923E25",
  2017: "#FC5500",
  3000: "#A72920",
  3001: "#9B2423",
  3002: "#9B2321",
  3003: "#861A22",
  3004: "#6B1C23",
  3005: "#59191F",
  3007: "#3E2022",
  3009: "#6D342D",
  3011: "#782423",
  3012: "#C5856D",
  3013: "#972E25",
  3014: "#CB7375",
  3015: "#D8A0A6",
  3016: "#A63D30",
  3017: "#CA555D",
  3018: "#C63F4A",
  3020: "#BB1F11",
  3022: "#CF6955",
  3024: "#FF2D21",
  3026: "#FF2A1C",
  3027: "#AB273C",
  3028: "#CC2C24",
  3031: "#A63437",
  3032: "#701D24",
  3033: "#A53A2E",
  4001: "#816183",
  4002: "#8D3C4B",
  4003: "#C4618C",
  4004: "#651E38",
  4005: "#76689A",
  4006: "#903373",
  4007: "#47243C",
  4008: "#844C82",
  4009: "#9D8692",
  4010: "#BB4077",
  4011: "#6E6387",
  4012: "#6A6B7F",
  5000: "#304F6E",
  5001: "#0E4C64",
  5002: "#00387A",
  5003: "#1F3855",
  5004: "#191E28",
  5005: "#005387",
  5007: "#376B8C",
  5008: "#2B3A44",
  5009: "#215F78",
  5010: "#004F7C",
  5011: "#1A2B3C",
  5012: "#0089B6",
  5013: "#193153",
  5014: "#637D96",
  5015: "#007CAF",
  5017: "#005B8C",
  5018: "#048B8C",
  5019: "#005E83",
  5020: "#00414B",
  5021: "#007577",
  5022: "#222D5A",
  5023: "#41698C",
  5024: "#6093AC",
  5025: "#20697C",
  5026: "#0F3052",
  6000: "#3C7460",
  6001: "#366735",
  6002: "#325928",
  6003: "#50533C",
  6004: "#024442",
  6005: "#114232",
  6006: "#3C392E",
  6007: "#2C3222",
  6008: "#36342A",
  6009: "#27352A",
  6010: "#4D6F39",
  6011: "#6B7C59",
  6012: "#2F3D3A",
  6013: "#7C765A",
  6014: "#474135",
  6015: "#3D3D36",
  6016: "#00694C",
  6017: "#587F40",
  6018: "#60993B",
  6019: "#B9CEAC",
  6020: "#37422F",
  6021: "#8A9977",
  6022: "#3A3327",
  6024: "#008351",
  6025: "#5E6E3B",
  6026: "#005F4E",
  6027: "#7EBAB5",
  6028: "#315442",
  6029: "#006F3D",
  6032: "#237F52",
  6033: "#45877F",
  6034: "#7AADAC",
  6035: "#194D25",
  6036: "#04574B",
  6037: "#008B29",
  6038: "#00B51B",
  6039: "#B3C43E",
  7000: "#7A888E",
  7001: "#8C979C",
  7002: "#817863",
  7003: "#797669",
  7004: "#9A9B9B",
  7005: "#6B6E6B",
  7006: "#766A5E",
  7008: "#745F3D",
  7009: "#5D6058",
  7010: "#585C56",
  7011: "#52595D",
  7012: "#575D5E",
  7013: "#575044",
  7015: "#4F5358",
  7016: "#383E42",
  7021: "#2F3234",
  7022: "#4C4A44",
  7023: "#808076",
  7024: "#45494E",
  7026: "#374345",
  7030: "#928E85",
  7031: "#5B686D",
  7032: "#B5B0A1",
  7033: "#7F8274",
  7034: "#92886F",
  7035: "#C5C7C4",
  7036: "#979392",
  7037: "#7A7B7A",
  7038: "#B0B0A9",
  7039: "#6B665E",
  7040: "#989EA1",
  7042: "#8E9291",
  7043: "#4F5250",
  7044: "#B7B3A8",
  7045: "#8D9295",
  7046: "#7E868A",
  7047: "#C8C8C7",
  7048: "#817B73",
  8000: "#89693F",
  8001: "#9D622B",
  8002: "#794D3E",
  8003: "#7E4B27",
  8004: "#8D4931",
  8007: "#70462B",
  8008: "#724A25",
  8011: "#5A3827",
  8012: "#66332B",
  8014: "#4A3526",
  8015: "#5E2F26",
  8016: "#4C2B20",
  8017: "#442F29",
  8019: "#3D3635",
  8022: "#1A1719",
  8023: "#A45729",
  8024: "#795038",
  8025: "#755847",
  8028: "#513A2A",
  8029: "#7F4031",
  9001: "#E9E0D2",
  9002: "#D6D5CB",
  9003: "#ECECE7",
  9004: "#2B2B2C",
  9005: "#0E0E10",
  9006: "#A1A1A0",
  9007: "#868581",
  9010: "#F1EDE1",
  9011: "#27292B",
  9012: "#F8F2E1",
  9016: "#F1F1EA",
  9017: "#29292A",
  9018: "#C8CBC4",
  9022: "#858583",
  9023: "#787B7A",
};
